import { timestampFormatter } from '@retainerclub/common';
import PropTypes from 'prop-types';

function TableRowColumnEnrolled({ subscription, nextShipment, activeStates }) {
  return (
    <>
      {subscription.patient.firstName} {subscription.patient.lastName}
      <br />
      {nextShipment && activeStates.includes(subscription.state) && (
        <span className="text-gray-600 italic">
          next shipment:{' '}
          {timestampFormatter(nextShipment.expectedShippedAt, false)}
        </span>
      )}
    </>
  );
}

TableRowColumnEnrolled.propTypes = {
  subscription: PropTypes.object.isRequired,
  nextShipment: PropTypes.object,
  activeStates: PropTypes.array.isRequired,
};

export default TableRowColumnEnrolled;
